import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./ServicesTrustedAcrossIndustries.css";

// ================= ENGLISH DATA
import * as EN from "../../../Data/ServicesTrustedAcrossIndustriesData";
// ================= FRENCH DATA
import * as FR from "../../../Data/French/ServicesTrustedAcrossIndustriesDataFR";

export default function ServicesTrustedAcrossIndustries({ currentLanguage = "en" }) {
  const location = useLocation();
  const isFrench = currentLanguage === "fr";

  // ================= MOBILE CHECK
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ================= PATH → KEY MAPPING
  const pathMap = {
    "/services/auditandassurance/financialstatementaudit": "financialStatementAudit",
    "/services/auditandassurance/ifrsadvisoryservice": "ifrsAdvisoryService",
    "/services/auditandassurance/otherassuranceservice": "otherAssuranceService",
    "/services/auditandassurance/internalcontrolframework": "internalControlFramework",
    "/services/advisory/dealadvisory": "dealAdvisory",
    "/services/advisory/restructuring": "restructuring",
    "/services/advisory/duediligence": "dueDiligence",
    "/services/advisory/forensicservices": "forensicServices",
    "/services/advisory/riskadvisory": "riskAdvisory",
    "/services/advisory/technologyadvisoryservice": "technologyAdvisoryService",
    "/services/advisory/valuations": "valuations",
    "/services/taxation/corporatetax": "corporateTax",
    "/services/taxation/mergerandacquisition": "mergerAndAcquisition",
    "/services/taxation/transferpricing": "transferPricing",
    "/services/taxation/valueaddedtax": "valueAddedTax",
    "/services/taxation/internationaltax": "internationalTax",
    "/services/taxation/excisetax": "exciseTax",
    "/services/taxation/taxrestructuring": "taxRestructuring",
    "/services/taxation/economicsubstanceregulations": "economicSubstanceRegulations",
    "/services/businessserviceoutsourcing/financeandaccounting": "financeAndAccounting",
    "/services/businessserviceoutsourcing/corporateadvisoryservices": "corporateAdvisoryServices",
    "/services/businessserviceoutsourcing/expensesclaimmanagement": "expensesClaimManagement",
    "/services/businessserviceoutsourcing/payrollhrservices": "payrollHrServices",
    "/services/businessserviceoutsourcing/secondment": "secondment",
    "/services/businessserviceoutsourcing/treasuryservice": "treasuryService",
    "/services/strategies/marketresearch": "marketResearch",
    "/services/strategies/businessconsulting": "businessConsulting",
    "/services/corporateservices/entitysetup": "entitySetup",
    "/services/corporateservices/outsourcedfinanceregulatorycompliance": "outsourcedFinanceRegulatoryCompliance",
    "/services/corporateservices/companysecertarial": "companySecretarial",
  };

  const key = pathMap[location.pathname];
  
  // ================= LANGUAGE DATA SELECT
  // Only get data if key exists, otherwise return null
  const data = key ? (isFrench ? FR[key] : EN[key]) : null;

  // If no data found for this path, don't render the component
  if (!data) {
    return null;
  }

  return (
    <section className="services-industry-main section">
      <div className="row">

        {/* LEFT */}
        <div className="col-lg-5">
          <div className="d-flex align-items-center">
            <div className="industry-line me-3"></div>
            <p className="section-subtitle mb-0">{data.heading}</p>
          </div>

          <h2 className="section-title">{data.subheading}</h2>

          <p className="section-text">{data.description}</p>

          <button className="services-btn">
            {data.buttonText}
            <img
              src="/assets/icons/RightArrow.png"
              alt="arrow"
              className="indsutry-arrow-icon"
            />
          </button>
        </div>

        {/* RIGHT SIDE CARDS */}
        <div className="col-lg-7 d-flex justify-content-center align-items-center">
          <div>
            <div
              className={`row justify-content-center g-3 ${
                isMobile ? "industries-row-mobile" : "industries-row"
              }`}
            >
              {data.industries.map((item, index) => (
                <div className="col-auto" key={index}>
                  <div className="process-card text-center gradient-border">
                    <img src={item.img} alt={item.title} className="process-icon" />
                    <div className="process-line"></div>
                    <p className="process-text mt-2 mb-0">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}